export default __webpack_public_path__ + "static/banner-how-do-colours-affect-your-home-79d385eca6670baca8f62b9267927da2.webp";